<template>
  <div
      class="d-flex flex-column"
      style="width: 100%; height: 100vh"
      :style="showModalNoticia ? 'background: white' : `background: ${corBackground}`"
  >
    <v-row
        v-if="showModalNoticia"
        no-gutters
        style="width: 100%; z-index: 10"
        class="headerInterno align-self-start ma-0 pa-0"
        :style="{
        'background-color':
          dataModalExibirNoticia.cod_portal === 'oglobo'
            ? corPortal
            : dataModalExibirNoticia.hex_cor_pagina,
      }"
    >
      <v-col
          cols="2"
          lg="1"
          md="1"
          sm="1"
          class="d-flex closeBtnWrapper pa-0 ma-0 ml-2"
          style="height: 100%"
      >
        <v-icon
            class="mx-4 closeModal"
            @click="showModalNoticia = false"
            color="#eeeeee"
            x-large
        >mdi-close</v-icon
        >
      </v-col>
      <v-col
          cols="2"
          lg="1"
          md="1"
          sm="1"
          class="d-flex align-center"
          style="height: 100%"
      >
        <div
            class="logoPortalHeaderInterno d-flex flex-column align-center justify-center ma-0 pa-0 mt-1"
            v-html="logoPortal"
        ></div>
      </v-col>
      <v-divider
          v-if="dataModalExibirNoticia.cod_portal === 'oglobo'"
          vertical
          class="mx-2"
          style="
          border-right-width: 1px;
          border-color: #ccc;
          min-height: 60%;
          max-height: 60%;
          align-self: center;
        "
      ></v-divider>
      <v-col
          v-if="dataModalExibirNoticia.cod_portal !== 'oglobo'"
          cols="8"
          lg="8"
          md="8"
          sm="8"
          class="d-flex justify-center ma-0 pa-0"
          style="height: 100%"
      >
        <h2 class="font-weight-light">
          {{ dataModalExibirNoticia.dsc_editoria_nome | upperCase }}
        </h2>
      </v-col>
      <v-col
          v-if="dataModalExibirNoticia.cod_portal === 'oglobo'"
          cols="8"
          lg="8"
          md="8"
          sm="8"
          class="d-flex ma-0 pa-0 ml-2"
          style="height: 100%"
      >
        <h2
            style="
            display: flex;
            height: auto;
            font-family: 'Times New Roman', Times, serif !important;
            font-size: 1.4rem;
            text-align: center;
          "
            class="font-weight-thin mt-2"
        >
          {{ dataModalExibirNoticia.dsc_redacao.split("/").at(-1).trim() }}
        </h2>
      </v-col>
    </v-row>
    <div
        class="cardWrapper d-flex flex-column align-center mt-8 align-self-center"
        :style="cssProps"
        v-if="!showModalNoticia"
    >
      <div class="topBar d-flex align-center justify-center" :style="topBarStyle">
        <div class="d-flex align-center justify-center" style="height: 4rem; width: 100%">
          <div
              class="logoPortal d-flex flex-column align-center justify-center"
              v-html="logoPortal"
          ></div>
        </div>
      </div>
      <div class="noticiasWrapper d-flex flex-column mt-7 mb-4" v-if="noticiasModeradas">
        <div v-for="item in noticiasModeradas.items" :key="item.cod_noticia" class="mt-3">
          <div class="d-flex" @click="handleClickNoticia(item)">
            <v-img v-if="item.url_capa" :src="item.url_capa" class="capaNoticia" />
            <span class="titleNoticia" :class="item.url_capa ? 'ml-4' : ''">
              {{ item.dsc_titulo_resumido }}
            </span>
          </div>
          <div class="mt-2">
            <p class="resumoNoticia">{{ item.dsc_subtitulo }}</p>
          </div>
        </div>
      </div>
    </div>
    <ModalExibirNoticia
        v-if="showModalNoticia && dataModalExibirNoticia.cod_portal !== 'oglobo'"
        :noticia="dataModalExibirNoticia"
        class="align-self-start justify-self-start"
    />
    <ModalExibirNoticiaOGLOBO
        v-if="showModalNoticia && dataModalExibirNoticia.cod_portal === 'oglobo'"
        :noticia="dataModalExibirNoticia"
        class="align-self-start justify-self-start"
    />
  </div>
</template>

<script>
import ModalExibirNoticia from "@/components/Modal/Noticia/ModalExibirNoticia.vue";
import ModalExibirNoticiaOGLOBO from "@/components/Modal/Noticia/ModalExibirNoticiaOGLOBO.vue";

export default {
  components: { ModalExibirNoticia, ModalExibirNoticiaOGLOBO },
  props: {
    noticiasModeradas: [Array, Object],
    corPortal: String,
    logoPortal: String,
    corBackground: String,
    corCardNoticias: String,
  },
  data() {
    return {
      showModalNoticia: false,
      dataModalExibirNoticia: {},
    };
  },
  computed: {
    cssProps() {
      return {
        "--bg-portal-color": this.corPortal,
        "--bg-card-noticias": this.corCardNoticias || "#eeeeee",
        "--text-color": this.getTextColorBasedOnBackground(),
      };
    },
    topBarStyle() {
      const hasG1Portal = this.noticiasModeradas?.items?.some(item => item.cod_portal === 'g1');

      if (hasG1Portal) {
        return {
          'background-color': '#C4170C'
        };
      }

      return {
        'background-color': this.corPortal
      };
    }
  },
  filters: {
    upperCase(string) {
      return string.toUpperCase();
    },
  },
  methods: {
    handleClickNoticia(noticia) {
      this.showModalNoticia = true;
      this.dataModalExibirNoticia = noticia;
    },
    /**
     * Enhanced color contrast calculation using WCAG standards
     * @param {string} hexColor - Hex color string
     * @returns {boolean} - True if color is dark
     */
    isColorDark(hexColor) {
      let hex = hexColor;

      if (hex.charAt(0) === '#') {
        hex = hex.substring(1);
      }

      if (hex.length === 3) {
        hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
      }

      if (hex.length === 8) {
        hex = hex.substring(0, 6);
      }

      if (hex.length !== 6) {
        return false;
      }

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Enhanced luminance calculation using sRGB color space
      const toLinear = (c) => {
        c = c / 255;
        return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      };

      const rLinear = toLinear(r);
      const gLinear = toLinear(g);
      const bLinear = toLinear(b);

      const luminance = 0.2126729 * rLinear + 0.7151522 * gLinear + 0.0721750 * bLinear;

      // Use WCAG threshold for better contrast
      return luminance < 0.18;
    },

    /**
     * Get contrast ratio between two colors
     * @param {string} color1 - First color
     * @param {string} color2 - Second color
     * @returns {number} - Contrast ratio
     */
    getContrastRatio(color1, color2) {
      const getLuminance = (hex) => {
        let color = hex;
        if (color.charAt(0) === '#') {
          color = color.substring(1);
        }

        const r = parseInt(color.substring(0, 2), 16) / 255;
        const g = parseInt(color.substring(2, 4), 16) / 255;
        const b = parseInt(color.substring(4, 6), 16) / 255;

        const toLinear = (c) => c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);

        return 0.2126729 * toLinear(r) + 0.7151522 * toLinear(g) + 0.0721750 * toLinear(b);
      };

      const lum1 = getLuminance(color1);
      const lum2 = getLuminance(color2);
      const brightest = Math.max(lum1, lum2);
      const darkest = Math.min(lum1, lum2);

      return (brightest + 0.05) / (darkest + 0.05);
    },

    /**
     * Get optimal text color with better contrast
     * @returns {string} - Text color hex value
     */
    getTextColorBasedOnBackground() {
      const backgroundColor = this.corCardNoticias || "#eeeeee";

      // Enhanced text options for better perceptual contrast
      const textOptions = ["#000000", "#333333", "#666666", "#ffffff", "#f0f0f0"];
      let bestColor = "#333333";
      let bestContrast = 0;

      textOptions.forEach(textColor => {
        const contrast = this.getContrastRatio(backgroundColor, textColor);
        if (contrast > bestContrast) {
          bestContrast = contrast;
          bestColor = textColor;
        }
      });

      // Ensure minimum WCAG AA contrast ratio (4.5:1)
      return bestContrast >= 4.5 ? bestColor : (this.isColorDark(backgroundColor) ? "#ffffff" : "#000000");
    }
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 2rem;
}
.cardWrapper {
  width: 400px;
  height: 90%;
  background-color: var(--bg-card-noticias);
  border-radius: var(--sc-radius-md);
}

.topBar {
  width: 100%;
  height: 4rem !important;
  border-radius: var(--sc-radius-md) var(--sc-radius-md) 0 0;
  box-shadow: 1px 2px 2px #171717;
}

.logoPortal {
  min-width: 65% !important;
  height: 65% !important;

  svg {
    min-width: 100%;
    height: 100% !important;
    fill: white;
    align-self: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  svg path {
    fill: white;
    align-self: center;
  }
}

.logoPortalHeaderInterno {
  width: 90%;
  height: 75% !important;

  svg {
    width: 100%;
    height: 100% !important;
    fill: white;
    align-self: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  svg path {
    fill: white;
    align-self: center;
  }
}
.noticiasWrapper {
  width: 90%;
  height: 620px;
  overflow-y: scroll;
  scrollbar-color: #cccccc #bababa;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.noticiasWrapper::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.capaNoticia {
  width: 100px;
  height: 80px;
  cursor: pointer;
}
.titleNoticia {
  color: var(--bg-portal-color);
  font-weight: var(--sc-weight-bold);
  font-size: 1rem;
  cursor: pointer;
  line-height: 1.4rem;
}

.resumoNoticia {
  color: var(--text-color);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2rem;
  word-wrap: break-word;
}
body::-webkit-scrollbar {
  display: none;
}

.headerInterno {
  height: 3rem !important;
  position: fixed;
  top: 0;
}

.closeModal::before {
  font-size: 2rem;
  color: #eeeeee;
  font-weight: 400;
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 300px) and (max-width: 767px) {
  .closeBtnWrapper {
    max-width: fit-content !important;
    margin-left: 0 !important;
  }
  .closeModal {
    margin: 0 !important;
  }
  .cardWrapper {
    width: 100%;
    height: 100%;
    background-color: var(--bg-card-noticias);
    border-radius: var(--sc-radius-md);
    margin: 0 !important;
  }
  .noticiasWrapper {
    height: 88%;
  }
  .capaNoticia {
    width: 100px;
    height: 80px;
    cursor: pointer;
  }
  .titleNoticia {
    color: var(--bg-portal-color);
    font-weight: var(--sc-weight-bold);
    font-size: 1.2rem;
    cursor: pointer;
    line-height: 1.4rem;
  }
  .resumoNoticia {
    color: var(--text-color);
    font-size: 1.1rem;
    font-weight: 400;
    line-height: 1.2rem;
    word-wrap: break-word;
  }
  .headerInterno {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: unset;
  }
  .col-8 {
    flex: 0 0 60% !important;
    max-width: 60% !important;
  }

  .logoPortalHeaderInterno {
    width: 90%;
    height: 70% !important;
    margin-left: 4px !important;

    svg {
      width: 100%;
      height: 100% !important;
      fill: white;
      align-self: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    svg path {
      fill: white;
      align-self: center;
    }
  }
}

// tablets
@media (min-width: 768px) and (max-width: 1024px) {
  .closeBtnWrapper {
    max-width: fit-content !important;
    margin-left: 4px !important;
  }
  .closeModal {
    margin: 0 !important;
  }

  .noticiasWrapper {
    height: 88%;
  }
  .cardWrapper {
    width: 100%;
    height: 100%;
    background-color: var(--bg-card-noticias);
    border-radius: var(--sc-radius-md);
    margin: 0 !important;
  }
  .capaNoticia {
    width: 100px;
    height: 80px;
    cursor: pointer;
  }
  .titleNoticia {
    color: var(--bg-portal-color);
    font-weight: var(--sc-weight-bold);
    font-size: 1.2rem;
    cursor: pointer;
    line-height: 1.4rem;
  }
  .resumoNoticia {
    color: var(--text-color);
    font-size: 1.1rem;
    font-weight: 400;
    line-height: 1.2rem;
    word-wrap: break-word;
  }
  .headerInterno {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: unset;
  }
  .col-8 {
    flex: 0 0 75% !important;
    max-width: 75% !important;
  }

  .logoPortalHeaderInterno {
    width: 80%;
    height: 60% !important;
    margin-left: 4px !important;

    svg {
      width: 100%;
      height: 100% !important;
      fill: white;
      align-self: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    svg path {
      fill: white;
      align-self: center;
    }
  }
}
</style>